import React, { cloneElement, useCallback, useEffect, useState } from 'react';

function CheckWrongAnsertMultipleChoiceQuestion({
  children,
  data,
}) {
  const [questions, setQuestions] = useState(null);
  const [answerView, setAnswerView] = useState([]);
  const [answers, setAnswers] = useState([]);

  const handleQestion = useCallback(() => {
    const wransrObjctExmpCn = data.wransrObjctExmpCn ? data.wransrObjctExmpCn.split(';') : []
    setQuestions(wransrObjctExmpCn);
    setAnswerView(data.qstCransr.split(';'));
    setAnswers(data.qstCransr.split(';'))
  }, [data]);


  const handleChange = useCallback((e) => {
    return;
  });

  return cloneElement(
    children || <React.Fragment />,
    {
      type: 'checkWrong',
      wrongAnswer: data.mbrAnsr.indexOf('phantom') > -1 ? null : data.mbrAnsr.split(';'),
      questions: questions,
      answerView: answerView,
      answers: answers,
      handleChange: handleChange,
      answersQuestion: data,
      handleQestion: handleQestion,
    }
  )
}

export default CheckWrongAnsertMultipleChoiceQuestion;